// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2fd4M","title":"FrontImage_title__1nXoV"};